import { useState, useEffect } from "react";
import apiClient from "../../utils/apiClient";
import YourMealsForm from "../../components/preferences/YourMeals";
import { useNavigate } from "react-router-dom";
import Modal from "../../components/Modal";
import MoveToTour from "../../components/MoveToTour";
import { useLoading } from "../../contexts/LoadingContext";


export default function OnboardYourMeals() {
  const [prefs, setPrefs] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const { setSuppressLoader } = useLoading(); //supress loading

  useEffect(() => {
    setSuppressLoader(true);
    return () => setSuppressLoader(false);
  }, [setSuppressLoader]);

  useEffect(() => {
    apiClient.get(`/users/preferences`).then(res => setPrefs(res.data));
  }, []);

  const handleSave = async (updated) => {
    const res = await apiClient.put(`/users/preferences`, updated);
    setPrefs(res.data);
    setShowModal(true); // Show modal after save
    //show the modal with MoveToTour component as the content.
    //navigate("/onboard/getting-started");

    // Fire off the generate initital recipes requese
    apiClient.post('/recipes/initial').catch((e) => console.error('Initial recipe generation failed', e));
  };

  return (
    <>
    <div className="max-w-md mx-auto mt-8 space-y-6 px-4">
      <h1 className="text-2xl font-bold ">About your recipes</h1>
      <p>Here are the basic settings for your recipes including any dislikes or dietary goals we should consider.</p>
      {prefs && <YourMealsForm prefs={prefs} onSubmit={handleSave} btnText={"Next"}/>}
    </div>
    <Modal component={MoveToTourWrapper} isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
    // Wrap with navigate to pass it down
    function MoveToTourWrapper() {
      return <MoveToTour onComplete={() => navigate("/onboard/getting-started")} onSkip={() => navigate("/subscribe")}/>;
    }
}
